/* assets/senko.js */
document.addEventListener('DOMContentLoaded', function () {

  /* ── FAQ ACCORDION ── */
  document.querySelectorAll('.senko-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.senko-faq__item');
      var open = item.classList.contains('is-open');
      document.querySelectorAll('.senko-faq__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      if (!open) item.classList.add('is-open');
    });
  });

  /* ── BURGER MENU ── */
  var burger = document.querySelector('.senko-nav__burger');
  var drawer = document.querySelector('.senko-nav__drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = burger.classList.toggle('is-open');
      drawer.classList.toggle('is-open', open);
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        burger.classList.remove('is-open');
        drawer.classList.remove('is-open');
      });
    });
  }

  /* ── SCROLLED NAV ── */
  var nav = document.querySelector('.senko-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('is-scrolled', window.scrollY > 40);
    });
  }

  /* ── COLOR PICKER ── */
  document.querySelectorAll('.senko-cp__dot, .senko-cp__dot-pill').forEach(function (dot) {
    dot.addEventListener('click', function () {
      var color = dot.getAttribute('data-color');
      document.querySelectorAll('.senko-cp__dot, .senko-cp__dot-pill').forEach(function (d) {
        d.classList.remove('is-active');
      });
      document.querySelectorAll('.senko-cp__img-wrap').forEach(function (w) {
        w.classList.remove('is-active');
      });
      document.querySelectorAll('.senko-cp__panel').forEach(function (p) {
        p.classList.remove('is-active');
      });
      dot.classList.add('is-active');
      var img   = document.querySelector('[data-target="' + color + '"]');
      var panel = document.querySelector('[data-color-panel="' + color + '"]');
      if (img)   img.classList.add('is-active');
      if (panel) panel.classList.add('is-active');
    });
  });

  /* ── MATERIALS TOGGLE ── */
  var toggles   = document.querySelectorAll('.senko-mat__toggle');
  var matPanels = document.querySelectorAll('.senko-mat__panel');
  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mat = btn.getAttribute('data-mat');
      toggles.forEach(function (b) { b.classList.remove('is-active'); });
      matPanels.forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var target = document.querySelector('[data-panel="' + mat + '"]');
      if (target) target.classList.add('is-active');
    });
  });

  /* ── CONFIRMATION POPUP ── */
  var confirmPopup   = document.getElementById('senko-confirm-popup');
  var confirmClose   = document.getElementById('senko-confirm-close');
  var confirmDismiss = document.getElementById('senko-confirm-dismiss');
  var confirmBack    = confirmPopup ? confirmPopup.querySelector('.senko-popup__backdrop') : null;

  function openConfirmPopup() {
    if (!confirmPopup) return;
    confirmPopup.classList.add('is-open');
    confirmPopup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeConfirmPopup() {
    if (!confirmPopup) return;
    confirmPopup.classList.remove('is-open');
    confirmPopup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (confirmClose)   confirmClose.addEventListener('click', closeConfirmPopup);
  if (confirmDismiss) confirmDismiss.addEventListener('click', closeConfirmPopup);
  if (confirmBack)    confirmBack.addEventListener('click', closeConfirmPopup);

  /* ── PRIORITY DEPOSIT POPUP ── */
  var depositPopup = document.getElementById('senko-deposit-popup');
  var depositClose  = document.getElementById('senko-deposit-close');
  var depositYes     = document.getElementById('senko-deposit-yes');
  var depositNo       = document.getElementById('senko-deposit-no');
  var depositBack   = depositPopup ? depositPopup.querySelector('.senko-popup__backdrop') : null;

  function openDepositPopup() {
    if (!depositPopup) return;
    depositPopup.classList.add('is-open');
    depositPopup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDepositPopup() {
    if (!depositPopup) return;
    depositPopup.classList.remove('is-open');
    depositPopup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (depositClose) depositClose.addEventListener('click', closeDepositPopup);
  if (depositBack)  depositBack.addEventListener('click', closeDepositPopup);

  /* Declining the pledge still rolls into the "You're all set" confirmation. */
  if (depositNo) {
    depositNo.addEventListener('click', function () {
      closeDepositPopup();
      setTimeout(openConfirmPopup, 250);
    });
  }

  if (depositYes) {
    depositYes.addEventListener('click', function () {
      var variantId = depositYes.getAttribute('data-variant-id');
      if (!variantId) {
        /* No $1 deposit product selected in theme settings yet. */
        console.warn('Senkō: select a $1 deposit product in Theme Settings \u2192 Priority Deposit.');
        closeDepositPopup();
        return;
      }

      depositYes.disabled = true;
      depositYes.classList.add('senko-btn-loading');

      function goToCheckout() {
        var email = null;
        try { email = localStorage.getItem('senko_email'); } catch (e) {}
        var url = '/checkout';
        if (email) {
          url += '?checkout[email]=' + encodeURIComponent(email);
        }
        window.location.href = url;
      }

      function handleCartError(err) {
        console.error('Senkō: could not add the $1 pledge to cart.', err);
        depositYes.disabled = false;
        depositYes.classList.remove('senko-btn-loading');
      }

      /* Check the cart first so repeat clicks/visits don't stack quantity —
         the pledge should always end up as exactly 1, never 2, 3, etc. */
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var lineIndex = -1;
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].variant_id) === String(variantId)) {
              lineIndex = i;
              break;
            }
          }

          if (lineIndex === -1) {
            /* Not in the cart yet — add exactly 1. */
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });
          }

          if (cart.items[lineIndex].quantity !== 1) {
            /* Already in the cart with the wrong quantity — force it back to 1. */
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: lineIndex + 1, quantity: 1 })
            });
          }

          /* Already in the cart with quantity 1 — nothing to change. */
          return Promise.resolve({ ok: true });
        })
        .then(function (res) {
          if (res && res.ok === false) throw new Error('Cart update failed');
          goToCheckout();
        })
        .catch(handleCartError);
    });
  }

  /* ── COPY DISCOUNT CODE ── */
  var copyBtn      = document.getElementById('senko-copy-btn');
  var discountCode = document.getElementById('senko-discount-code');
  if (copyBtn && discountCode) {
    copyBtn.addEventListener('click', function () {
      var code = discountCode.textContent.trim();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = 'Copied!';
          copyBtn.classList.add('is-copied');
          setTimeout(function () {
            copyBtn.textContent = 'Copy';
            copyBtn.classList.remove('is-copied');
          }, 2000);
        });
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity  = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        copyBtn.textContent = 'Copied!';
        copyBtn.classList.add('is-copied');
        setTimeout(function () {
          copyBtn.textContent = 'Copy';
          copyBtn.classList.remove('is-copied');
        }, 2000);
      }
    });
  }

  /* ── AUTO-OPEN PLEDGE POPUP WHEN SHOPIFY REDIRECTS BACK WITH ?confirmed=1 ── */
  if (new URLSearchParams(window.location.search).get('confirmed') === '1') {
    window.history.replaceState({}, '', window.location.pathname);
    setTimeout(openDepositPopup, 300);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeEmailPopup();
      closeConfirmPopup();
      closeDepositPopup();
    }
  });

  /* ── EMAIL CAPTURE POPUP ── */
  var emailPopup      = document.getElementById('senko-email-popup');
  var emailPopupClose = document.getElementById('senko-email-popup-close');
  var emailBackdrop   = emailPopup ? emailPopup.querySelector('.senko-popup__backdrop') : null;
  var emailInput      = document.getElementById('senko-nav-email-input');
  var emailError      = document.getElementById('senko-nav-email-error');

  function openEmailPopup() {
    if (!emailPopup) return;
    emailPopup.classList.add('is-open');
    emailPopup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (emailInput) setTimeout(function () { emailInput.focus(); }, 80);
  }

  function closeEmailPopup() {
    if (!emailPopup) return;
    emailPopup.classList.remove('is-open');
    emailPopup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (emailPopupClose) emailPopupClose.addEventListener('click', closeEmailPopup);
  if (emailBackdrop)   emailBackdrop.addEventListener('click', closeEmailPopup);

  ['senko-nav-email-form', 'hero-reserve-form', 'faq-reserve-form'].forEach(function (id) {
    var form = document.getElementById(id);
    if (!form) return;
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[type="email"]');
      if (input && input.value.trim()) {
        localStorage.setItem('senko_email', input.value.trim());
      }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.classList.add('senko-btn-loading');
        btn.disabled = true;
      }
    });
  });

  /* Client-side validation for the nav popup form only */
  var navForm = document.getElementById('senko-nav-email-form');
  if (navForm) {
    navForm.addEventListener('submit', function (e) {
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        e.preventDefault();
        if (emailError) {
          emailError.textContent = 'Please enter a valid email address.';
          emailError.style.display = 'block';
        }
        return;
      }
      if (emailError) emailError.style.display = 'none';
    });
  }

  /* ── HEADER RESERVE NOW BUTTON ── */
  document.querySelectorAll('[data-open-reserve], #nav-reserve-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openEmailPopup();
    });
  });

});